import * as types from '../mutations'
import axios from 'axios'

const state = {
    token: localStorage.getItem('token') || null,
    user: {},
}

const mutations = {

    [types.AUTH_LOGOUT] (state)
    {
        state.token = null
        localStorage.setItem('token', state.token)
    },

    [types.AUTH_LOGIN_SUCCESS] (state, payload)
    {
        state.token = payload
        localStorage.setItem('token', state.token)
    },

    [types.AUTH_SET_USER] (state, payload)
    {
        state.user = payload
    }

}

const actions = {

    init({state, dispatch})
    {
        if (state.token && state.token != 'null')
        {
            dispatch('fetchUser')
        }
    },

    authLogin({commit, dispatch}, payload)
    {
        if (payload && payload.token && payload.user)
        {
            commit(types.AUTH_LOGIN_SUCCESS, payload.token)
            commit(types.AUTH_SET_USER, payload.user)
        } else {
            dispatch('authLogout')
        }
    },

    authLogout({commit}, payload)
    {
        commit(types.AUTH_LOGOUT)
        commit(types.AUTH_SET_USER, {})
    },

    fetchUser({commit, dispatch})
    {
        return new Promise(async(resolve, reject) => {
            try {
                const auth = await axios.get(process.env.API_URL + '/v1/user')
                commit(types.AUTH_SET_USER, auth.data)
                if (auth.data.locale)
                    dispatch('localeSet', auth.data.locale)
                resolve(auth.data)
            } catch(e) {
                dispatch('authLogout')
            }
        })
    },

}

const getters = {
    authLoggedIn: state => state.token !== null && state.token !== undefined && state.token !== 'null',
    authUser: state => JSON.parse(JSON.stringify(state.user))
}

axios.interceptors.request.use(
    config => {
        if (state.token)
        {
            config.headers.common['Authorization'] = `Bearer ${state.token}`
        }
        return config
    },
    error => Promise.reject(error)
)

export default {
    state,
    mutations,
    actions,
    getters,
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js